import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96f9f9ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid page" }
const _hoisted_2 = { class: "page__content" }
const _hoisted_3 = { class: "page__header" }
const _hoisted_4 = { class: "asahi-logo-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "asahi-header-menu hidden-lg-down" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiLogoNew = _resolveComponent("AsahiLogoNew")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!
  const _component_AsahiBsFooter = _resolveComponent("AsahiBsFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AsahiLogoNew, {
            onClick: _cache[0] || (_cache[0] = () => _ctx.$navigate('/login'))
          })
        ]),
        _hoisted_5,
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex align-items-center justify-content-end primary-white", {'w-100': _ctx.isMobile}])
        }, [
          _createVNode(_component_AsahiButton, {
            type: "primary-gold",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$navigate('/login'))),
            class: "login-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Login')), 1)
            ]),
            _: 1
          })
        ], 2)
      ]),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      _createVNode(_component_AsahiBsFooter, {
        onLanguagechange: _ctx.changeLanguage,
        language: _ctx.languages,
        "active-language": _ctx.activeLanguage,
        user: _ctx.user,
        "footer-data": _ctx.portalPageMenuLink,
        "brand-data": _ctx.footerLinksBrands,
        "header-data": _ctx.portalPageMenuLink,
        cookies: _ctx.footerLinksCookies,
        "terms-of-use": _ctx.footerLinksTermsOfUse,
        "privacy-policy": _ctx.footerLinksPrivacyPolicy
      }, null, 8, ["onLanguagechange", "language", "active-language", "user", "footer-data", "brand-data", "header-data", "cookies", "terms-of-use", "privacy-policy"])
    ])
  ]))
}